module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp2-01-fb17ba8286e9e2557d7cee056e847be9.png";